// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"223":"7f8596af5b2ad2580c08","678":"e9c8bf7efd82e95bd884","843":"e2cca1933ebbd801fdb1","883":"5ef0787b7361bb74ca7c"}[chunkId] + ".js";
};